import { render, staticRenderFns } from "./HomeIndex.vue?vue&type=template&id=f0daed1c&scoped=true&"
import script from "./HomeIndex.vue?vue&type=script&lang=js&"
export * from "./HomeIndex.vue?vue&type=script&lang=js&"
import style0 from "./HomeIndex.vue?vue&type=style&index=0&id=f0daed1c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0daed1c",
  null
  
)

export default component.exports